import 'styles/templates/ethics.scss'

import 'scripts/vue/main'

import Vue from 'vue'
import VModal from 'vue-js-modal'

Vue.use(VModal)

window.PSTheme.Vue.Ethics = new Vue({
  name: 'EthicsWrapper',
  components: {
    'ethics': require('../vue/templates/Ethics.vue').default
  }
}).$mount('.ethics')
